import { Map as MainMap, MapLayer } from '@/map'

export function Map() {
  return (
    <MainMap selectionContext="crud" selectionCategory="depots" mapId="ww-depot-map">
      <MapLayer uid="order" />
      <MapLayer uid="depot" interactive interactiveOnUnmount />
      <MapLayer uid="region" />
      <MapLayer uid="roadSegment" />
      <MapLayer uid="geofence" visible={false} />
      <MapLayer uid="routePolyline" />
      <MapLayer uid="place" />
      <MapLayer uid="device" />
      <MapLayer uid="vehicle" />
    </MainMap>
  )
}
